<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>RABBITMQ COMMS</div>
				<h2 waHeading="l" waText>Broker-Backed Messaging for Scale</h2>
				<p waBody="m" waColorText="quiet" waText>Add the dependency, enable Web STOMP on RabbitMQ, and publish.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<markdown [data]="mdContent_144"></markdown>
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Broker-Managed Durability</h3>
							<p waBody="m" waColorText="quiet" waText>Persistent exchanges survive broker restarts. Scale horizontally by adding app instances behind the same broker.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Angular Directive</h3>
							<p waBody="m" waColorText="quiet" waText>The &#91;data-rabbit-groups&#93; directive subscribes Angular components to RabbitMQ exchanges declaratively. Subscribe on mount, unsubscribe on destroy.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Automatic Exchange Lifecycle</h3>
							<p waBody="m" waColorText="quiet" waText>Exchanges are declared on first subscribe. Session exchanges auto-delete. Custom exchanges persist.</p>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>SockJS Fallback</h3>
							<p waBody="m" waColorText="quiet" waText>STOMP.js connects via WebSocket. SockJS provides transparent fallback for browsers or proxies that block WebSocket.</p>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>